module.exports = "<!-- Copyright (C) 2016 NooBaa -->\n\n<editor params=\"label: 'Timezone'\">\n    <dropdown params=\"\n        options: options,\n        selected: selected,\n        filter: true\n    \"></dropdown>\n</editor>\n";
